<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size sm_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <slot name="header">
                            {{ $t('FIELD.REJECT.DETAIL') }}
                        </slot>
                    </dt>
                    <dd>
                        <div class="reject_wrap auto_height">
                            <dl class="dl_select">
                                <dd data-input-type="select">
                                    <select class="slt_white w100p" v-model="comments">
                                        <option value="">{{ $t('FIELD.SELECT.REJECT.REASON') }}</option>
                                        <option
                                            v-for="item in commentList"
                                            :key="'commentList' + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </dd>
                            </dl>

                            <p class="rj_title">
                                {{ $t('FIELD.DESCRIBE.REJECT.REASON') }}
                                <em class="txt_mandatory" v-show="'' === comments || '09' === comments">*</em>
                            </p>
                            <dl class="rj_textarea">
                                <dd data-input-type="textarea">
                                    <textarea class="textarea_ty w100p scroll" maxlength="200" v-model="comment">
                                    </textarea>
                                    <span class="textarea_counter">{{ commentLength }} / 200</span>
                                </dd>
                            </dl>
                        </div>
                    </dd>
                    <!-- 200707수정(버튼 하단으로 이동) S -->
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_white" @click="$emit('close')">
                                    {{ $t('BUTTON.GLOBAL.CANCEL') }}
                                </a>
                                <a href="javascript:" class="btn_blue" @click="save()">
                                    {{ $t('BUTTON.GLOBAL.SAVE') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/service';
import { SDLUtil } from '@/utils';

export default {
    name: 'RejectPopup',
    props: {
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            comment: '',
            comments: '',
            commentLength: 0,
            commentList: [],
        };
    },
    watch: {
        comment() {
            this.commentLength = SDLUtil.textLength(this.comment);
        },
        comments() {
            let comments = this.comments;
            if ('09' !== SDLUtil.nvl(comments, '09')) {
                const idx = this.commentList.findIndex(function(item) {
                    return item.code === comments;
                });
                this.comment = this.commentList[idx].codeName;
            }
        },
    },
    mounted() {
        this.getCommonCodeList('EUR_REJECT_REASON').then(data => {
            for (const iterator of data) {
                if ('08' !== iterator.code) {
                    this.commentList.push(iterator);
                }
            }
            // this.commentList = data;
        });
    },
    methods: {
        async getCommonCodeList(v) {
            const codeResp = await api.getCommonCodeList(v, 'A');
            return codeResp;
        },
        save() {
            let comments = this.comments;
            let comment = this.comment;
            let commentLength = this.commentLength;
            let commentList = this.commentList;

            // if (SDLUtil.isNull(comments) || '09' === comments) {
            //     if (SDLUtil.isNull(comment)) {
            //         SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.FIELD.INSERT.MENDATORY'));
            //         return false;
            //     } else if (200 < commentLength) {
            //         SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.DATA.MAX.LENGTH', ['200']));
            //         return false;
            //     } else {
            //         this.rtnFunc('0', comment);
            //         this.$emit('close');
            //     }
            // } else {
            //     const idx = commentList.findIndex(function(item) {
            //         return item.code === comments;
            //     });
            //     this.rtnFunc(comments, commentList[idx].codeName);
            //     this.$emit('close');
            // }

            if (SDLUtil.isNull(comment)) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.FIELD.INSERT.MENDATORY'));
                return false;
            } else if (200 < commentLength) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.DATA.MAX.LENGTH', ['200']));
                return false;
            } else {
                this.rtnFunc(comments, comment);
                this.$emit('close');
            }
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/admin/RejectPopup.vue